import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["clear", "export", "form", "rangeForm", "rangeLink", "refresh", "status"]
  static values = { delay: { type: Number, default: 400 } }

  connect() {
    this.formTarget.classList.add("is-enhanced")
    this.exportPath = new URL(this.exportTarget.href).pathname
    this.refreshPath = new URL(this.refreshTarget.href).pathname
    this.updateLinks()
  }

  disconnect() {
    window.clearTimeout(this.searchTimer)
  }

  apply() {
    window.clearTimeout(this.searchTimer)
    this.updateLinks()
    this.formTarget.requestSubmit()
  }

  search() {
    window.clearTimeout(this.searchTimer)
    this.updateLinks()
    this.statusTarget.textContent = "Waiting for you to finish typing…"

    this.searchTimer = window.setTimeout(() => {
      this.formTarget.requestSubmit()
    }, this.delayValue)
  }

  markLoading() {
    window.clearTimeout(this.searchTimer)
    this.formTarget.classList.add("is-loading")
    this.formTarget.setAttribute("aria-busy", "true")
    this.statusTarget.textContent = "Updating users…"
  }

  finishLoading() {
    this.formTarget.classList.remove("is-loading")
    this.formTarget.removeAttribute("aria-busy")
    this.statusTarget.textContent = "Filters apply automatically"
  }

  updateLinks() {
    const formData = new FormData(this.formTarget)
    const query = new URLSearchParams(formData)
    const search = formData.get("q")?.trim()
    const registration = formData.get("registration")
    const plan = formData.get("plan")

    this.exportTarget.href = `${this.exportPath}?${query.toString()}`
    this.refreshTarget.href = `${this.refreshPath}?${query.toString()}`
    this.syncRangeLinks(query)
    this.syncRangeForm(formData)
    this.clearTarget.classList.toggle("d-none", !search && registration === "all" && plan === "all")
  }

  syncRangeLinks(directoryQuery) {
    this.rangeLinkTargets.forEach((link) => {
      const url = new URL(link.href)
      const range = url.searchParams.get("user_range")
      const query = new URLSearchParams(directoryQuery)

      query.delete("user_start_date")
      query.delete("user_end_date")
      query.set("user_range", range)
      link.href = `${url.pathname}?${query.toString()}`
    })
  }

  syncRangeForm(directoryData) {
    const fields = ["q", "registration", "plan", "per_page"]

    fields.forEach((name) => {
      this.rangeFormTarget.elements.namedItem(name).value = directoryData.get(name) || ""
    })
  }
}
